module.exports = __webpack_public_path__ + "img/1564845269.73eec90b.jpg";